var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('recommend-form',{on:{"on-save":function($event){return _vm.save()}},model:{value:(_vm.recommend),callback:function ($$v) {_vm.recommend=$$v},expression:"recommend"}})}
var staticRenderFns = []

export { render, staticRenderFns }